import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import exam from './slices/examSlice'
import session from './slices/sessionSlice'
import config from './slices/configSlice'
import attempt from './slices/attemptSlice'
import bookmark from './slices/bookmarkSlice'
import user from './slices/userSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        exam,
        session,
        config,
        attempt,
        bookmark,
        user,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
